import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="relative bg-background-950 text-white py-16 md:py-20 px-4 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12 mb-14">
          <div>
            <h3 className="font-heading text-xl font-bold text-white mb-4">Superbuy Spreadsheet</h3>
            <p className="text-white/60 text-sm leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
              Your independent resource hub for organized product discovery. We curate and organize Superbuy
              Spreadsheet collections across 14 categories to help international shoppers make smarter decisions.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-4" style={{ fontFamily: 'var(--font-label)' }}>
              Navigation
            </h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Home
              </Link>
              <Link to="/superbuy-sheet-guide" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Complete Guide
              </Link>
              <Link to="/superbuy-spreadsheet-review" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Review
              </Link>
              <Link to="/superbuy-spreadsheet-beginner-guide" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Beginner Guide
              </Link>
            </nav>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-4" style={{ fontFamily: 'var(--font-label)' }}>
              Top Guides
            </h4>
            <nav className="flex flex-col gap-2.5">
              <Link to="/superbuy-spreadsheet-shoes" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Shoes Guide
              </Link>
              <Link to="/superbuy-spreadsheet-hoodies" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Hoodies Guide
              </Link>
              <Link to="/superbuy-spreadsheet-best-finds" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Best Finds 2026
              </Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'var(--font-body)' }}>
                Main Website
              </a>
            </nav>
          </div>

          <div>
            <h4 className="font-semibold text-white text-sm mb-4" style={{ fontFamily: 'var(--font-label)' }}>
              Important Disclaimer
            </h4>
            <p className="text-white/50 text-sm leading-relaxed" style={{ fontFamily: 'var(--font-body)' }}>
              This website is an independent informational resource. We are not the official platform.
              Users should verify sellers, prices, shipping policies, and local regulations before purchasing.
              All external links open on our partner website.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs" style={{ fontFamily: 'var(--font-body)' }}>
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved. An independent research platform.
          </p>
          <div className="flex items-center gap-4">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white/70 transition-colors duration-200 text-xs" style={{ fontFamily: 'var(--font-body)' }}>
              Privacy
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white/70 transition-colors duration-200 text-xs" style={{ fontFamily: 'var(--font-body)' }}>
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}